import { render, staticRenderFns } from "./IssueCertificatesModal.vue?vue&type=template&id=3bd227a8&scoped=true&"
import script from "./IssueCertificatesModal.vue?vue&type=script&lang=js&"
export * from "./IssueCertificatesModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueCertificatesModal.vue?vue&type=style&index=0&id=3bd227a8&prod&lang=css&"
import style1 from "./IssueCertificatesModal.vue?vue&type=style&index=1&id=3bd227a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd227a8",
  null
  
)

export default component.exports